module.exports = __webpack_public_path__ + "img/fanhuiicon.9161b277.svg";